<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: "PointsConfig",
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }],
      permission: {
        add: 'pointsConfig:add',
        update: 'pointsConfig:update',
        delete: 'pointsConfig:delete',
        deleteBatch: 'pointsConfig:deleteBatch'
      },
      url: {
        get: '/pointsConfig/listByCondition',
        add: '/pointsConfig/add',
        update: '/pointsConfig/update',
        delete: '/pointsConfig/delete/',
        delete_batch: '/pointsConfig/deleteBatch',
        status: '/pointsConfig/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        width: '',
      }, {
        field: 'actionName',
        label: '动作名称',
        show: true,
        width: '',
      }, {
        field: 'points',
        label: '积分',
        show: true,
        width: '',
      },{
        field: 'type',
        label: '类型',
        show: {
          type: 'tag',
          tags: [{
            key: 1,
            value: '会员注册',
          }, {
            key: 2,
            value: '积分兑换率 默认 1U：100',
          }, {
            key: 3,
            value: '聊天AI',
          }, {
            key: 4,
            value: '绘画AI',
          }, {
            key: 5,
            value: '绘画Ai连续生成',
          }, {
            key: 6,
            value: '视频AI',
          }]
        },
      }, {
        field: 'createTime',
        label: '时间',
        show: true,
        width: '',
      }],
      operate: [],
      formFields: {
        addTitle: '积分配置表',
        updateTitle: '积分配置表',
        model: [{
          field: 'actionName',
          label: '动作名称',
          type: 'input',
          placeholder: '动作名称',
          rules: [{message: '请输入动作名称', trigger: 'blur', required: false}],
          add: true,
          update: true,
        }, {
          field: 'points',
          label: '积分',
          type: 'input',
          placeholder: '积分',
          rules: [{message: '请输入积分', trigger: 'blur', required: true}],
          add: true,
          update: true,
        },{
          field: 'type',
          label: '类型',
          type: 'select',
          selectData: [{
            id: 1,
            name: '会员注册'
          }, {
            id: 2,
            name: '积分兑换率 默认 1U：100'
          }, {
            id: 3,
            name: '聊天AI'
          }, {
            id: 4,
            name: '绘画AI'
          }, {
            id: 5,
            name: '绘画AI *4 连续生成'
          }, {
            id: 6,
            name: '视频AI'
          }],
          placeholder: '请选择类型',
          rules: [{
            message: '请选择类型', trigger: 'blur', required: true
          }],
          add: true,
          update: true,
        }, {
          field: 'agentId',
          label: '代理：',
          type: 'select',
          placeholder: '请选择代理',
          rules: [{required: true, message: '请选择代理', trigger: 'blur'}],
          selectUrl: '/agent/getAll',
          selectData: [],
          add: true,
          update: true,
          filterable: true,
        }],
      }
    }
  }
}
</script>

<style scoped>

</style>
